import React from "react";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import useTranslationAdmin from "../useTranslationAdmin.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import RefreshButton from "../../common/widgets/RefreshButton.js";
import "./RecruiterListBlock.scss";
import RecruiterList from "./RecruiterList.js";

function RecruiterListBlock() {
  const { t, loading: tLoading } = useTranslationAdmin();
  useShowLoader(tLoading, "RecruiterListBlock");

  return (
    <div className="RecruiterListBlock">
      <Row>
        <Col>
          <h1>{t("admin:admin_recruiter_list_title")}</h1>
        </Col>
        <Col className={"button-col"}>
          <RefreshButton />
        </Col>
      </Row>
      <Row>
        <Col>
          <RecruiterList />
        </Col>
      </Row>
    </div>
  );
}

export default RecruiterListBlock;
